export interface UlProps {
	title?: string;
	desc?: string;
	descItems?: string[];
}

export enum UlSize {
	Small,
	Medium,
	Large,
}
